<template>
    <div :id="target" class="modal fade" tabindex="-1">
        <div class="modal-dialog modal-md">
            <div class="modal-content">
                <div class="modal-header bg-ums">
                    <h5 class="modal-title">Message Detail</h5>
                    <button type="button" class="close" data-dismiss="modal" style="top:20%">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col">
                            <div class="card">
                                <div class="card-body">
                                    <basic-input label="Seq No" type="text"  v-model="info.seq" vertical readonly/>
                                    <basic-input label="Event Id" type="text"  v-model="formattedEventId" vertical readonly/>
                                    <basic-input label="Client Code" type="text"  v-model="info.clientCd" vertical readonly/>
                                    <basic-input label="Message Type" type="text"  v-model="formattedMsgType" vertical readonly/>
                                    <div class="form-group row">
                                        <label class="col-form-label col-lg-3">{{'Recipient'}}</label>
                                        <div class="col-lg-9">
                                            <!-- background color css 맞추기 위한 readonly 속성 -->
                                            <div class="form-control" readonly :style="info.addr && 'height:auto'">
                                                {{info.addr}}
                                            </div>
                                        </div>
                                    </div>
                                    <basic-input label="Registered Date" type="text"  v-model="formattedRegDtm" vertical readonly/>
                                    <basic-input label="Send Date" type="text"  v-model="formattedUpdDtm" vertical readonly/>
                                    <basic-input label="Status" type="text"  v-model="formattedStatus" vertical readonly/>
                                    <div class="form-group row">
                                        <label class="col-form-label col-lg-3"></label>
                                        <div class="col-lg-9 input-group">
                                            <input class="form-control" id='msgResult' type="text"  v-model="info.msgResult" readonly/>
                                            <div class="input-group-append">
                                                <button class="btn btn-secondary" data-toggle="tooltip" data-placement="top" title="copy message result." @click="copyText('msgResult')">
                                                    <i class="icon-files-empty icon-1x"/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <basic-input label="Params" type="text"  v-model="info.params" vertical readonly/>
                                    <basic-input label="Subject" type="text"  v-model="info.subject" vertical readonly/>
                                    <div class="form-group row">
                                        <label class="col-form-label col-lg-3">{{'Content'}}</label>
                                        <div class="col-lg-9">
                                            <textarea class="form-control" v-model="info.body" rows="5" readonly/>
                                        </div>
                                    </div>
                                    <basic-input label="Language" type="text"  v-model="formattedLanguage" vertical readonly/>
                                    <basic-input label="Sms Sender" type="text"  v-model="info.smsSenderId" vertical readonly/>
                                    <button class="btn bg-ums" style="width: 100%" @click="closeModal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BasicInput from "@/components/form/input/BasicInput";
import {SnotifyPosition} from "vue-snotify";

export default {
    name: "LogDetailModal",
    components: {BasicInput},
    props: {
        target: {
            type: String,
            required: true
        },
        info: {
            type: Object,
            required: true,
        }
    },
    computed: {
        formattedRegDtm: function () {
            return this.$filters.datetimeFormat(this.info.sysRegDtm)
        },
        formattedUpdDtm: function () {
            return this.$filters.datetimeFormat(this.info.sysUpdDtm)
        },
        formattedStatus: function () {
            const option = this.$store.getters[this.$const.GETTERS.LOG_STATUS_TYPE_OPTIONS]()
            const status = this.$filters.changeOptionsValueToText(this.info.status, option) || ''
            return status.toUpperCase()
        },
        formattedEventId: function () {
            return `${this.info.eventId} (${this.info.eventNm})`
        },
        formattedLanguage: function () {
            const option = this.$store.getters[this.$const.GETTERS.FULL_LANGUAGE_OPTIONS]()
            return this.$filters.changeOptionsValueToText(this.info.lang, option)
        },
        formattedMsgType: function  () {
            const option = this.$store.getters[this.$const.GETTERS.MSG_TYPE_OPTIONS]()
            return this.$filters.changeOptionsValueToText(this.info.msgType, option)
        }
    },
    mounted() {

    },
    methods: {
        closeModal: function () {
            $(`#${this.target}`).modal('hide')
        },
        copyText: function (inputId) {
            const input = document.getElementById(inputId)
            input.select()
            document.execCommand('copy')
            this.$notify.alert(`${inputId} copied!`, {
                position:SnotifyPosition.rightTop,
                backdrop:0,
                timeout:1000,
                buttons: [],
            })
        }
    }
}
</script>

<style scoped>

</style>